import Immutable from 'seamless-immutable';
import ActionTypes from './../common/ActionTypes';

const DEFAULT_STATE = Immutable([]);

export default function(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {
    case ActionTypes.WORK_LOG_TODAY_CLEAR:
      return DEFAULT_STATE;
    case ActionTypes.WORK_LOG_CREATED:
      return state.concat([action.workLog]);
    case ActionTypes.WORK_LOG_UPDATED:
      return Immutable.flatMap(state, value => {
        if (action.workLog.id === value.id) {
          return action.workLog;
        }
        return value;
      });
    case ActionTypes.WORK_LOG_DELETED:
      return Immutable.flatMap(state, value => {
        if (action.workLog.id === value.id) {
          return [];
        }
        return value;
      });
    case ActionTypes.PROJECT_DELETED:
      return Immutable.flatMap(state, value => {
        if (action.project.id === value.projectId) {
          return [];
        }
        return value;
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/workLogsToday.js